export { default } from './OfferEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferEdit/index.js